import { Component, Input, OnInit, AfterViewInit, forwardRef } from '@angular/core';
import { IPkInputDateFieldProps } from './pk-input-date-field.props';
import { getFirstError } from '@nx-monorepo/cms-base/helpers';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'pk-input-date-field',
  templateUrl: './pk-input-date-field.component.html',
  styleUrls: ['./pk-input-date-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PkInputDateFieldComponent),
      multi: true
    }
  ]
})
export class PkInputDateFieldComponent  {
  @Input()
  settings: IPkInputDateFieldProps;

}

